module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sa-dbdc272cb217fd407ff810ae4b6e2762.svg";